import React from "react";
import { ButtonProps, DeliveryInfoButton, useDisclosure } from "sprint-common-web";

import { DeliveryInfoAside } from "./DeliveryInfoAside";

export type DeliveryInfoButtonAsideProps = Pick<ButtonProps, "disabled"> & {
    itemId: string;
    isLabeled?: boolean;
};

export const DeliveryInfoButtonAside: React.FunctionComponent<DeliveryInfoButtonAsideProps> = (
    props: DeliveryInfoButtonAsideProps
) => {
    const { isOpen, onClose, onOpen } = useDisclosure();
    const { itemId, disabled, isLabeled } = props;

    return (
        <>
            <DeliveryInfoButton onClick={onOpen} isLabeled={isLabeled} disabled={disabled} />
            <DeliveryInfoAside deliveryId={itemId} isOpen={isOpen} onClose={onClose} />
        </>
    );
};
